import { connect } from 'react-redux';

import { getAvatarLoading, getPhoto } from 'store/modules/profile/selectors';
import { showError } from 'store/modules/app/actions';
import { uploadPhoto } from 'store/modules/profile/actions';

import ProfileAvatar from './ProfileAvatar';

const mapStateToProps = (state) => ({
  loading: getAvatarLoading(state),
  photoUrl: getPhoto(state),
});

const mapDispatchToProps = (dispatch) => ({
  onPhotoChange: (photo) => dispatch(uploadPhoto(photo)),
  onUploadError: (message) => dispatch(showError(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAvatar);
